import { create } from 'zustand';
import { YouTubePlayer } from '../components/remark_directives/yt_inner/YouTubeEmbedInner';

interface YTVideoPlayerState {
  // The currently playing video ID (user-initiated)
  currentlyPlayingId: string | null;
  
  // The currently playing player instance (for pausing)
  currentPlayer: YouTubePlayer | null;

  // Set a video as the currently playing one (user-initiated)
  // Returns a Promise that resolves when any pause operation completes
  setCurrentlyPlaying: (id: string, player: YouTubePlayer) => Promise<void>;
  
  // Clear the currently playing video
  clearCurrentlyPlaying: (id: string) => void;
}

export const useYTVideoPlayerStore = create<YTVideoPlayerState>((set, get) => ({
  currentlyPlayingId: null,
  currentPlayer: null,
  
  setCurrentlyPlaying: async (id, player) => {
    const { currentlyPlayingId, currentPlayer } = get();
    
    // If there's already a playing video and it's different from this one, pause it
    if (currentPlayer && currentlyPlayingId !== id) {
      try {
        // Wait for the pause operation to complete
        await currentPlayer.pauseVideo();
      } catch (error) {
        console.warn(`Error pausing previous video:`, error);
      }
    }
    
    // Set this as the currently playing video
    set({ currentlyPlayingId: id, currentPlayer: player });
  },
  
  clearCurrentlyPlaying: (id) => {
    const { currentlyPlayingId } = get();
    
    // Only clear if this is the currently playing video
    if (currentlyPlayingId === id) {
      set({ currentlyPlayingId: null, currentPlayer: null });
    }
  }
}));
